"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _shared = require("./shared");
var _A11yInfoProvider = require("../A11yInfoProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const animateProps = {
  keyTimes: _shared.SPINNER_KEYTIMES,
  repeatCount: 'indefinite'
};
const Spinner = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    size,
    color,
    indicatorBackgroundColor,
    thickness,
    label,
    isStatic = false
  } = _ref;
  const {
    reduceMotionEnabled
  } = (0, _A11yInfoProvider.useA11yInfo)();
  const reduceMotion = reduceMotionEnabled || isStatic;
  const strokeWidth = thickness * _shared.SVG_SIZE / size;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ref: ref,
    width: `${size}px`,
    height: `${size}px`,
    viewBox: `0 0 ${_shared.SVG_SIZE} ${_shared.SVG_SIZE}`,
    "aria-valuetext": label,
    role: "progressbar",
    "aria-busy": "true",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      fill: "none",
      stroke: indicatorBackgroundColor,
      strokeWidth: strokeWidth,
      cx: _shared.SVG_CENTER,
      cy: _shared.SVG_CENTER,
      r: _shared.SPINNER_RADIUS
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
      fill: "none",
      stroke: color,
      strokeWidth: strokeWidth,
      strokeLinecap: "round",
      cx: _shared.SVG_CENTER,
      cy: _shared.SVG_CENTER,
      r: _shared.SPINNER_RADIUS,
      strokeDasharray: `${_shared.SPINNER_DASHARRAY_MIN * _shared.SVG_CIRCUMFERENCE}, ${_shared.SPINNER_DASHARRAY_MAX * _shared.SVG_CIRCUMFERENCE}`,
      strokeDashoffset: "0"
      // Circle rotated -90° so that 0% is at the top (12 o'clock).
      ,
      transform: _shared.ROTATION_TRANSFORM,
      children: reduceMotion ? null : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("animateTransform", {
          attributeName: "transform",
          type: "rotate",
          from: "0 24 24",
          to: `${_shared.SPINNER_ROTATION_DEGREES} ${_shared.SVG_CENTER} ${_shared.SVG_CENTER}`,
          dur: `${_shared.DURATION}ms`,
          repeatCount: "indefinite",
          additive: "sum"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("animate", {
          attributeName: "stroke-dasharray",
          dur: `${_shared.DURATION}ms`,
          values: `
                  ${_shared.SPINNER_DASHARRAY_MIN * _shared.SVG_CIRCUMFERENCE},${_shared.SPINNER_DASHARRAY_MAX * _shared.SVG_CIRCUMFERENCE};
                  ${_shared.SPINNER_DASHARRAY_HALF * _shared.SVG_CIRCUMFERENCE},${_shared.SPINNER_DASHARRAY_HALF * _shared.SVG_CIRCUMFERENCE};
                  ${_shared.SPINNER_DASHARRAY_MIN * _shared.SVG_CIRCUMFERENCE},${_shared.SPINNER_DASHARRAY_MAX * _shared.SVG_CIRCUMFERENCE}
                `,
          ...animateProps
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("animate", {
          attributeName: "stroke-dashoffset",
          dur: `${_shared.DURATION}ms`,
          values: `
                  0;
                  0;
                  -${_shared.SPINNER_DASHOFFSET_FACTOR * _shared.SVG_CIRCUMFERENCE}
                `,
          ...animateProps
        })]
      })
    })]
  });
});
Spinner.displayName = 'Spinner';
Spinner.propTypes = _shared.propTypes;
var _default = exports.default = Spinner;